module.exports = __webpack_public_path__ + "static/media/btn_apple_en.d66c9a3b.svg";